module.exports = __webpack_public_path__ + "img/choice02.710d8917.png";